import { render, staticRenderFns } from "./GerenciaCadastroEstruturaAnoLetivo.vue?vue&type=template&id=215bd758"
import script from "./GerenciaCadastroEstruturaAnoLetivo.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroEstruturaAnoLetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports